import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <header className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-subtitle">Last updated: November 1, 2024</p>
        </header>

        <div className="privacy-card">
          <div className="privacy-card-content">
            <h2 className="privacy-section-title">Information We Collect</h2>
            <p className="privacy-text">
              When you visit our website, we may collect certain information about your device, 
              your interaction with our website, and information necessary to process your purchases.
            </p>
          </div>
        </div>

        <div className="privacy-card">
          <div className="privacy-card-content">
            <h2 className="privacy-section-title">How We Use Your Information</h2>
            <ul className="privacy-list">
              <li>To process your orders and maintain your account</li>
              <li>To enhance your shopping experience</li>
              <li>To communicate with you about your orders and promotions</li>
              <li>To improve our website and services</li>
            </ul>
          </div>
        </div>

        <div className="privacy-card">
          <div className="privacy-card-content">
            <h2 className="privacy-section-title">Information Sharing</h2>
            <p className="privacy-text">
              We share your information with our payment processors and shipping partners 
              only to the extent necessary to provide our services. We do not sell or rent 
              your personal information to third parties.
            </p>
          </div>
        </div>

        <div className="privacy-card">
          <div className="privacy-card-content">
            <h2 className="privacy-section-title">Security Measures</h2>
            <p className="privacy-text">
              We implement appropriate technical and organizational security measures to 
              protect your personal information against unauthorized access, alteration, 
              disclosure, or destruction.
            </p>
          </div>
        </div>

        <div className="privacy-card">
          <div className="privacy-card-content">
            <h2 className="privacy-section-title">Your Rights</h2>
            <ul className="privacy-list">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for marketing communications</li>
            </ul>
          </div>
        </div>

        
      </div>
    </div>
  );
};

export default PrivacyPolicy;